import React, { useEffect, useState } from "react";
import UifPage from "../../entities/UifPage";
import AuthService from "../../api/AuthService";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useAlert } from "../../context/AlertContext";
import { useLocation } from "react-router-dom";
const Uif = () => {
  const [getUif, setGetUif] = useState("");
  const { showAlert } = useAlert();
  const location = useLocation();
  const {uifCountry} = location.state||{};

  useEffect(() => {
    getUifs();
  }, []);

  const getUifs = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getUif(uifCountry);
      if (result?.success) {
        setGetUif(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const deleteUif = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteUif(id);
      if (result?.success) {
        getUifs();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  const CreateUif = async (fixed, rate, countryTax, datefrom, dateTo,maxCap) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.createUif(
        fixed,
        rate,
        countryTax,
        datefrom,
        dateTo,
        maxCap
      );
      if (result?.success) {
        getUifs();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  const handleEditUifs = async (selectedId, fixed, rate, countryTax, datefrom, dateTo, maxCap) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.EditUif(
        selectedId, fixed, rate, countryTax, datefrom, dateTo, maxCap
      );
      if (result?.success) {
        getUifs();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  return (
    <>
      <UifPage getUif={getUif} deleteUif={deleteUif} CreateUif={CreateUif} handleEditUifs={handleEditUifs} uifCountry={uifCountry}/>
    </>
  );
};
export default Uif;
